module.exports = __webpack_public_path__ + "static/img/setcolor.f2bc2e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/setcolor.png
// module id = Bl0G
// module chunks = 110